<template>
  <div :class="$style.protocol">
    <the-protocol-preface />
    <div :class="$style.list">
      <the-protocol-item
        v-for="(el, index) in list"
        :key="index"
        :data="el"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import TheProtocolPreface from './TheProtocolPreface'
import TheProtocolItem from './TheProtocolItem'

export default {
  components: { TheProtocolPreface, TheProtocolItem },
  props: {
    list: {
      type: Array,
      default() {
        return []
      },
    },
  },
}
</script>

<style lang="less" module>
.protocol {
  padding-top: @padding-base;
}

.list {
  margin-top: 1.34rem;
  padding: @padding-title-bot 3.6rem @padding-base;
  background-color: #f5f6fb;

  @media screen and (max-width: @tablet-width) {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  @media screen and (max-width: @mini-width) {
    padding: 1rem;
  }
}
</style>
